window.addEventListener('load', () => {});

customElements.define('keec-modal', class extends HTMLElement {
  constructor() {
    super();
    this.dialogEl = null;
    this.closeElements = null;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }
 

  connectedCallback() {
    this.dialogEl = this.querySelector('dialog');
    this.closeElements = this.querySelectorAll('[data-close]');
    this.closeElements.forEach((el) => {
      el.addEventListener('click', this.close);
    });

    this.addEventListener('click', this.handleOutsideClick);
  }
  

  disconnectedCallback() {
    this.closeElements.forEach((el) => {
      el.removeEventListener('click', this.close);
    });
    this.removeEventListener('click', this.handleOutsideClick);
    this.dialogEl = null;
    this.closeElements = null;
  }

  open() {
    if(!this.dialogEl || this.dialogEl.open) return;
    this.dialogEl.showModal();
    document.body.classList.add('no-scroll');
  }

  close(e) {
    if(e) e.preventDefault();
    if(!this.dialogEl || !this.dialogEl.open) return;
    this.dialogEl.close();
    document.body.classList.remove('no-scroll');
    this.dialogEl.classList.remove('keec-modal--error');
    this.dialogEl.classList.remove('keec-modal--success');
    this.dialogEl.classList.remove('keec-modal--hidden');
    const forms = this.dialogEl.querySelectorAll('form.keec-modal__form');
    forms.forEach((form) => {
      form.reset();
    });
  }

  handleOutsideClick(e) {
    // https://blog.webdevsimplified.com/2023-04/html-dialog/
    const dialogDimensions = this.dialogEl.getBoundingClientRect()
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      this.close();
    }
  }
});